/* Extracted from the inline <script> in snippets/pc-guarantee-collection.liquid so browsers can cache it; loaded with defer. */
(function () {
  'use strict';

  var RELAY_BASE = 'https://relay.partcatalog.com/public';
  var FITS_API   = 'https://shopify.partcatalog.com/fits.php';
  var STATE_KEY  = 'pc_guarantee_v1';
  var UID_KEY    = 'relay_uid';
  var MAX_DISMISS = 2;

  var overlay = document.getElementById('pcgc-overlay');
  if (!overlay) return;

  function loadState() { try { return JSON.parse(localStorage.getItem(STATE_KEY)) || {}; } catch (e) { return {}; } }
  function saveState(patch) {
    var s = loadState();
    delete s.email;   /* drop an address an older build stored here */
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
    return s;
  }
  function getUid() {
    var uid = null;
    try { uid = localStorage.getItem(UID_KEY); } catch (e) {}
    if (!uid) {
      var m = document.cookie.match(/(?:^|;)\s*relay_uid=([^;]+)/);
      if (m) uid = decodeURIComponent(m[1]);
    }
    if (!uid || uid.length < 16) {
      uid = ('xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx').replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    try { localStorage.setItem(UID_KEY, uid); } catch (e) {}
    return uid;
  }
  function savedVehicle() {
    try { var raw = localStorage.getItem('pc_ymm_v1'); if (raw) return JSON.parse(raw); } catch (e) {}
    return null;
  }

  /* pending purchase while modal is open */
  var pending = null;   /* {form, sku, handle, title, fitMsg} */

  function stampAndSubmit(activated) {
    if (!pending) return;
    var form = pending.form;
    if (pending.fitMsg) {
      /* A vehicle-mode row (pc-collection-table.js) already carries a
         properties[Fitment] built from the collection.php line - vehicle +
         qualifier notes only. The verify message is the fuller one (adds
         Position and Note, same as the product page), so it replaces that
         value rather than being skipped; the row's own value stays as the
         fallback for adds that never verified. */
      var prop = form.querySelector('input[name="properties[Fitment]"]');
      if (!prop) {
        prop = document.createElement('input');
        prop.type = 'hidden';
        prop.name = 'properties[Fitment]';
        form.appendChild(prop);
      }
      /* Same normalization as the PDP modal: no "Fits your" prefix, no
         tags except <br /> - the cart badge supplies its own prefix. */
      var fv = pending.fitMsg.replace(/\s+/g, ' ').trim();
      fv = fv.replace(/<br\s*\/?>/gi, '<br />');
      fv = fv.replace(/<(?!br)[^>]*>/gi, '');
      fv = fv.replace(/^\s*Fits your\s+/i, '').trim();
      prop.value = fv;
    }
    var attrs = { relay_uid: getUid() };
    if (activated || loadState().captured) attrs.free_returns = 'activated';
    var finished = false;
    var go = function () {
      if (finished) return;
      finished = true;
      overlay.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
      plainSubmit(form);   /* AJAX add (pixel-tracked), native submit fallback */
    };
    setTimeout(go, 1500);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true
    }).then(go, go);
  }

  /* ---------- fits.php helpers (same endpoints the product-page checker uses) ---------- */
  function fitsGet(endpoint, params) {
    var q = new URLSearchParams();
    q.set('endpoint', endpoint);
    /* fits.php reads lowercase keys only ($_GET is case-sensitive), but qualifier
       names come back from extra-fields as "DriveType", "EngineBase", … - send
       them lower-cased (fitment-checker.js does the same via lcKeys) or the
       answer is ignored and the same field is asked again forever. */
    Object.keys(params).forEach(function (k) { if (params[k] != null && params[k] !== '') q.set(k.toLowerCase(), params[k]); });
    return fetch(FITS_API + '?' + q.toString(), { credentials: 'omit', headers: { Accept: 'application/json' } })   /* no cookies: fits.php has none */
      .then(function (r) { return r.json(); });
  }
  function verifyParams(vehicle, sku) {
    var p = { sku: sku };
    Object.keys(vehicle).forEach(function (k) {
      if (k !== 'sku' && vehicle[k] != null && vehicle[k] !== '') p[k.toLowerCase()] = vehicle[k];
    });
    return p;
  }
  function persistVehicle(v) {
    try {
      localStorage.setItem('ymm_selection', JSON.stringify(v));
      localStorage.setItem('pc_ymm_v1', JSON.stringify(v));
      document.cookie = 'ymm=' + encodeURIComponent(JSON.stringify(v)) + ';path=/;max-age=' + (60 * 60 * 24 * 180);
      document.cookie = 'pc_ymm=' + encodeURIComponent(JSON.stringify(v)) + ';path=/;max-age=' + (60 * 60 * 24 * 30) + ';SameSite=Lax';
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('vehicle:changed', { detail: v })); } catch (e) {}
  }
  function vehicleLabel(v) { return v ? [v.year, v.make, v.model].filter(Boolean).join(' ') : ''; }

  /* ---------- intercept every collection add-to-cart form ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.pcgcBypass === '1') return;
    if (form.id === 'pv2-product-form') return;   /* product page has its own modal */
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    var s = loadState();
    if ((s.dismissals || 0) >= MAX_DISMISS) {
      /* offer declined twice - plain add, but via AJAX so the pixel counts it */
      e.preventDefault();
      plainSubmit(form);
      return;
    }

    e.preventDefault();
    var variantId = idInput.value;

    /* find the product link nearest the clicked form */
    var scope = form.closest('tr, li, article, .card, .prod, td') || form.parentNode;
    var link = null;
    while (scope && scope !== document.body) {
      link = scope.querySelector('a[href*="/products/"]');
      if (link) break;
      scope = scope.parentNode;
    }
    var hm = link ? String(link.getAttribute('href')).match(/\/products\/([a-z0-9\-]+)/i) : null;
    var handle = hm ? hm[1] : null;
    if (!handle) { plainSubmit(form); return; }

    /* guard: never hold the purchase hostage to slow lookups */
    var done = false;
    var bail = setTimeout(function () { if (!done) { done = true; plainSubmit(form); } }, 4000);

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = (product.variants || []).filter(function (v) { return String(v.id) === String(variantId); })[0];
        var sku = variant ? variant.sku : null;
        if (!sku) throw new Error('no sku');
        pending = { form: form, sku: sku, handle: handle, title: product.title || '', fitMsg: null };

        var vehicle = savedVehicle();
        if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) {
          /* no vehicle yet: the checker, like the product page */
          done = true; clearTimeout(bail);
          openModal('vehicle');
          return;
        }
        return fitsGet('verify', verifyParams(vehicle, sku)).then(function (data) {
          if (done) return;
          done = true; clearTimeout(bail);
          afterVerify(!!data.fits, data, vehicle);
        });
      })
      .catch(function () {
        if (!done) { done = true; clearTimeout(bail); plainSubmit(form); }
      });
  }, true);

  /* after a verify (saved vehicle or the in-modal checker) */
  function afterVerify(fits, data, vehicle) {
    if (fits) {
      pending.fitMsg = data.message || ('Fits your ' + vehicleLabel(vehicle));
      if (loadState().captured) { stampAndSubmit(true); return; }   /* both known - no popup */
      openModal('email');
    } else {
      openModal('nofit', vehicle);
    }
  }

  /* AJAX add so Shopify's analytics pixel counts the cart addition - it
     instruments fetch/XHR only; a native form POST is invisible to it (the
     13-adds-vs-57-checkouts gap, Sep 2026). Native submit stays as the
     error fallback: tracking must never block a purchase. */
  function plainSubmit(form) {
    var fell = false;
    function fallback() {
      if (fell) return;
      fell = true;
      form.dataset.pcgcBypass = '1';
      try { form.submit(); } catch (e) {}
    }
    try {
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (!r.ok) { fallback(); return; }
        window.location.href = '/cart';
      }).catch(fallback);
    } catch (err) { fallback(); }
  }

  /* ---------- modal ---------- */
  var emailInput = document.getElementById('pcgc-email');
  var errorEl = document.getElementById('pcgc-error');
  var activateBtn = document.getElementById('pcgc-activate');

  var steps = { vehicle: document.getElementById('pcgc-step-vehicle'), nofit: document.getElementById('pcgc-step-nofit'), email: document.getElementById('pcgc-step-email') };
  function showStep(name) {
    Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
  }
  function openModal(step, vehicle) {
    if (step === 'email') {
      /* Backend message -> text nodes, never innerHTML */
      var fitEl = document.getElementById('pcgc-fit');
      fitEl.textContent = '\u2713 ';
      var fitSpan = document.createElement('span');
      fitEl.appendChild(fitSpan);
      var fitHtml = (pending && pending.fitMsg) ? pending.fitMsg : 'Fits your vehicle';
      if (window.PCFitmentText && window.PCFitmentText.renderMessage) { window.PCFitmentText.renderMessage(fitSpan, fitHtml); }
      else { fitSpan.textContent = String(fitHtml).replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, ''); }
    } else if (step === 'vehicle') {
      document.getElementById('pcgc-product').textContent = pending ? pending.title : '';
      startChecker();
    } else if (step === 'nofit') {
      document.getElementById('pcgc-nofit-title').textContent = "This part doesn't fit your " + (vehicleLabel(vehicle) || 'vehicle');
      var go = document.getElementById('pcgc-nofit-go');
      /* the collection page filters to the saved vehicle on load; brand landings do so in their parts view */
      go.href = document.getElementById('pc-brand') ? (location.pathname + '?view=parts') : (location.pathname + location.search);
    }
    window.__pcFitmentSurface = 'collection_modal';
    showStep(step);
    overlay.classList.add('is-visible');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      if (step === 'email') emailInput.focus();
      else if (step === 'vehicle') selYear.focus();
      else document.getElementById('pcgc-nofit-go').focus();
    }, 60);
  }

  /* ---------- in-modal fitment checker (no saved vehicle) ---------- */
  var selYear = document.getElementById('pcgc-year');
  var selMake = document.getElementById('pcgc-make');
  var selModel = document.getElementById('pcgc-model');
  var dynWrap = document.getElementById('pcgc-dynamic');
  var statusEl = document.getElementById('pcgc-status');
  var verifyBtn = document.getElementById('pcgc-verify');
  var chk = { selections: {}, dynamic: [] };

  function setOptions(sel, items, placeholder) {
    sel.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = placeholder; sel.appendChild(o);
    (items || []).forEach(function (it) {
      var op = document.createElement('option');
      if (it && typeof it === 'object') { op.value = it.value != null ? it.value : it.label; op.textContent = it.label != null ? it.label : it.value; }
      else { op.value = it; op.textContent = it; }
      sel.appendChild(op);
    });
    sel.disabled = !items || !items.length;
  }
  function setStatus(text, fail) { statusEl.textContent = text || ''; statusEl.classList.toggle('pcgc-fail', !!fail); }
  function readyToVerify() {
    if (!chk.selections.year || !chk.selections.make || !chk.selections.model) return false;
    return chk.dynamic.every(function (n) { return !!chk.selections[n]; });
  }
  function resetDynamic() { chk.dynamic = []; dynWrap.innerHTML = ''; ['year', 'make', 'model'].forEach(function () {}); Object.keys(chk.selections).forEach(function (k) { if (['year', 'make', 'model'].indexOf(k) === -1) delete chk.selections[k]; }); }
  function startChecker() {
    chk = { selections: {}, dynamic: [] };
    dynWrap.innerHTML = '';
    verifyBtn.disabled = true;
    setStatus('');
    setOptions(selYear, [], 'Loading years…'); selYear.disabled = true;
    setOptions(selMake, [], 'Select make'); setOptions(selModel, [], 'Select model');
    fitsGet('years', { sku: pending.sku }).then(function (d) {
      setOptions(selYear, (d.years || []).map(String), 'Select year');
    }).catch(function () { setStatus('Could not load vehicles. You can still add to cart.', true); setOptions(selYear, [], 'Select year'); });
  }
  selYear.addEventListener('change', function () {
    chk.selections = { year: selYear.value }; resetDynamic(); verifyBtn.disabled = true;
    setOptions(selMake, [], 'Loading makes…'); setOptions(selModel, [], 'Select model');
    if (!selYear.value) { setOptions(selMake, [], 'Select make'); return; }
    fitsGet('makes', { sku: pending.sku, year: selYear.value }).then(function (d) { setOptions(selMake, d.makes || [], 'Select make'); });
  });
  selMake.addEventListener('change', function () {
    chk.selections = { year: selYear.value, make: selMake.value }; resetDynamic(); verifyBtn.disabled = true;
    setOptions(selModel, [], 'Loading models…');
    if (!selMake.value) { setOptions(selModel, [], 'Select model'); return; }
    fitsGet('models', { sku: pending.sku, year: selYear.value, make: selMake.value }).then(function (d) { setOptions(selModel, d.models || [], 'Select model'); });
  });
  selModel.addEventListener('change', function () {
    chk.selections = { year: selYear.value, make: selMake.value, model: selModel.value }; resetDynamic();
    verifyBtn.disabled = true;
    if (selModel.value) loadNextExtra();
  });
  /* qualifiers (submodel, engine, ...) exactly as the product page asks for them */
  function loadNextExtra() {
    var q = { sku: pending.sku }; Object.keys(chk.selections).forEach(function (k) { q[k] = chk.selections[k]; });
    setStatus('');
    fitsGet('extra-fields', q).then(function (d) {
      var f = (d.fields || [])[0];
      if (!f) { verifyBtn.disabled = !readyToVerify(); return; }
      if (chk.dynamic.indexOf(f.name) === -1) chk.dynamic.push(f.name);
      var sel = document.createElement('select');
      sel.className = 'pcgc-sel'; sel.id = 'pcgc-dyn-' + f.name; sel.setAttribute('aria-label', f.label || f.name);
      setOptions(sel, f.options || [], 'Select ' + (f.label || f.name));
      sel.addEventListener('change', function () {
        /* everything after this field is stale */
        var idx = chk.dynamic.indexOf(f.name);
        chk.dynamic.splice(idx + 1).forEach(function (n) { delete chk.selections[n]; });
        while (sel.nextSibling) sel.nextSibling.remove();
        chk.selections[f.name] = sel.value;
        verifyBtn.disabled = true;
        if (sel.value) loadNextExtra();
      });
      dynWrap.appendChild(sel);
      sel.focus();
    }).catch(function () { verifyBtn.disabled = !readyToVerify(); });
  }
  verifyBtn.addEventListener('click', function () {
    if (!readyToVerify() || !pending) return;
    verifyBtn.disabled = true; setStatus('Checking…');
    var vehicle = {}; Object.keys(chk.selections).forEach(function (k) { vehicle[k] = chk.selections[k]; });
    fitsGet('verify', verifyParams(vehicle, pending.sku)).then(function (data) {
      var fits = !!data.fits;
      persistVehicle(vehicle);
      try { if (window.Relay && window.Relay.track) window.Relay.track('fitment_checked', { sku: pending.sku, result: fits ? 'fits' : 'does_not_fit', surface: 'collection_modal' }); } catch (e) {}
      setStatus('');
      afterVerify(fits, data, vehicle);
    }).catch(function () { setStatus('Could not verify fitment. Please try again.', true); verifyBtn.disabled = false; });
  });
  document.getElementById('pcgc-skip-vehicle').addEventListener('click', function () { stampAndSubmit(false); });
  document.getElementById('pcgc-nofit-change').addEventListener('click', function () { openModal('vehicle'); });
  document.getElementById('pcgc-nofit-add').addEventListener('click', function () { pending.fitMsg = null; stampAndSubmit(false); });
  function dismiss() {
    var s = loadState();
    saveState({ dismissals: (s.dismissals || 0) + 1 });
    if (window.Relay && window.Relay.track && pending) {
      window.Relay.track('add_to_cart', {
        sku: pending.sku,
        props: { form_id: 'atc_guarantee', captured: false, product_handle: pending.handle }
      });
    }
    stampAndSubmit(false);
  }
  document.getElementById('pcgc-skip').addEventListener('click', dismiss);
  document.getElementById('pcgc-close').addEventListener('click', dismiss);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });

  /* ---------- a11y: Escape, Tab trap, focus restore (ported from
     sections/main-cart-items.liquid pc-fitment-modal pattern) ---------- */
  document.addEventListener('keydown', function (e) {
    /* Bail if a nested widget already consumed this Escape (e.g. a .pc-fdd
       searchable dropdown, or any other future in-modal widget, calling
       preventDefault() on Escape to close just itself) - otherwise it would
       bubble up here and abandon/submit the whole guarantee flow instead. */
    if (e.defaultPrevented) return;
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) dismiss();
  });

  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusables = Array.prototype.filter.call(
      overlay.querySelectorAll('button, select, input, a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* Invariant this relies on: openModal()'s own focus() call (emailInput) is
     deferred via setTimeout, so this observer's callback - which runs as a
     microtask right after the synchronous classList.add('is-visible') - always
     fires and captures document.activeElement BEFORE that deferred focus() call
     runs. If a future edit makes that focus() call synchronous, this capture
     will grab the wrong element and focus-restore will break silently. */
  var pcgcLastFocus = null;
  new MutationObserver(function () {
    if (overlay.classList.contains('is-visible')) {
      if (!pcgcLastFocus) pcgcLastFocus = document.activeElement;
    } else if (pcgcLastFocus) {
      if (pcgcLastFocus.focus) pcgcLastFocus.focus();
      pcgcLastFocus = null;
    }
  }).observe(overlay, { attributes: true, attributeFilter: ['class'] });

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  activateBtn.addEventListener('click', function () {
    var email = (emailInput.value || '').trim();
    if (!validEmail(email)) {
      emailInput.classList.add('pcgc-invalid');
      errorEl.hidden = false;
      emailInput.focus();
      return;
    }
    emailInput.classList.remove('pcgc-invalid');
    errorEl.hidden = true;
    activateBtn.disabled = true;
    activateBtn.textContent = 'Activating…';

    var v = savedVehicle() || {};
    var payload = {
      uid: getUid(),
      email: email,
      form_id: 'atc_guarantee',
      consent: true,
      consent_text: document.getElementById('pcgc-consent-text').textContent.trim(),
      source_url: window.location.href,
      vehicle: { year: v.year, make: v.make, model: v.model },
      sku: pending ? pending.sku : null,
      product_handle: pending ? pending.handle : null,
      event_name: 'add_to_cart',
      props: { capture_variant: 'B-collection', product: pending ? pending.title : '' }
    };
    var finish = function () {
      saveState({ captured: true });   /* the address never goes into localStorage */
      stampAndSubmit(true);
    };
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); finish(); }, 4000);
    fetch(RELAY_BASE + '/identify.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      clearTimeout(timer);
      if (res.ok || res.status === 422) {
        if (res.status === 422) {
          activateBtn.disabled = false;
          activateBtn.textContent = 'Activate & Add to Cart';
          emailInput.classList.add('pcgc-invalid');
          errorEl.textContent = 'That email address doesn’t look right — please check it and try again.';
          errorEl.hidden = false;
          return;
        }
        finish();
      } else { finish(); }
    }, function () { clearTimeout(timer); finish(); });
  });
  emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); activateBtn.click(); }
  });
})();
